import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fb1f51b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "navigation" }

import MobileMenuNavItem from "../MobileMenuNavItem/index.vue";
import type { MobileMenuItem } from "../../types";


export default /*#__PURE__*/_defineComponent({
  props: {
    items: null,
    label: null
  },
  emits: ["navigate"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", {
    class: "nav",
    "aria-label": __props.label
  }, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
        return (_openBlock(), _createBlock(MobileMenuNavItem, {
          key: item.name,
          item: item,
          onNavigate: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('navigate')))
        }, null, 8, ["item"]))
      }), 128))
    ])
  ], 8, _hoisted_1))
}
}

})